import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EmailListEntryDto } from '@coin/importer/dto/util';
import { Subject, Subscription } from 'rxjs';
import { PopupAction } from '@coin/importer/core/util';
import { EmailListService } from '../../../services/organisation-management/email-list.service';
import { ToastService } from '../../../services/toast/toast.service';

@Component({
  selector: 'ci-email-list-entry-popup',
  templateUrl: './email-list-entry-popup.component.html',
  styleUrls: ['./email-list-entry-popup.component.scss'],
  standalone: false
})
export class EmailListEntryPopupComponent implements OnInit, OnDestroy {
  matDialogRef = inject<MatDialogRef<EmailListEntryPopupComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private toast = inject(ToastService);
  emailListService = inject(EmailListService);

  Action = PopupAction;
  entryList = this.data['entryList'] as EmailListEntryDto[];
  originalItem = this.data['item'] as EmailListEntryDto;
  action = this.data['action'] as PopupAction;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  item: any;
  uploading = false;
  uploadSubscription: Subscription;
  private destroy$: Subject<void> = new Subject<void>();

  ngOnInit(): void {
    if (this.data['action'] === PopupAction.New) {
      this.item = {
        Gid: '',
        EmailAddress: ''
      };
    } else {
      this.item = this.originalItem;
    }
  }

  async create() {
    if (this.validate()) {
      this.trimStringFields();
      await this.emailListService.createEntry(this.item);
    }
    this.emailListService.setTemporaryLog(this.item);
    this.close();
  }

  async update() {
    if (this.validate()) {
      this.trimStringFields();
      await this.emailListService.updateEntry(this.item);
    }
    this.close();
  }

  async delete() {
    if (this.validate()) {
      await this.emailListService.deleteEntry(this.item.Gid);
    }
    this.close();
    window.location.reload();
  }

  close() {
    if (this.uploading) {
      this.cancelUpload();
    } else {
      this.matDialogRef.close();
    }
  }

  private cancelUpload() {
    this.uploadSubscription?.unsubscribe();
    this.uploading = false;
    this.toast.info('Upload cancelled');
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  validate(): boolean {
    for (const [k] of Object.entries(this.item)) {
      if (!this.item[k] || this.validateString(this.item[k])) {
        return false;
      }
    }
    return true;
  }

  validateString(str: string): string | null {
    if (!str) {
      return 'cannot be empty';
    }
    if (str && !str.match(/^[A-Za-z0-9][ A-Za-z0-9]*$/)) {
      return 'has invalid characters';
    }
    return null;
  }

  trimStringFields() {
    this.item.Gid = this.item.Gid.trim();
    this.item.EmailAddress = this.item.EmailAddress.trim();
  }
}
